import { z } from "zod";
import { telemetryDataProviderSchema } from "../_shared";

export const getConnectedVehiclesDataProvidersByCompanyResponseSchema = z.array(
  z.object({
    vehicleUuid: z.uuid(),
    dataProvider: telemetryDataProviderSchema.nullable(),
  }),
);

export type GetConnectedVehiclesDataProvidersByCompanyResponse = z.infer<
  typeof getConnectedVehiclesDataProvidersByCompanyResponseSchema
>;
